module.exports = __webpack_public_path__ + "media/assets/images/blog/POST-LEANLINK-0120-f457bde415200e2c75295020521629f8.jpg";